import React from "react";
import { Chip } from "@mui/material";

const COLOR_MAP = {
  // leave / approvals
  pending: "warning",
  approved: "success",
  rejected: "error",
  cancelled: "default",
  // workflow
  draft: "default",
  open: "success",
  active: "primary",
  in_progress: "info",
  on_hold: "warning",
  completed: "success",
  closed: "default",
  paid: "success",
  // attendance
  present: "success",
  absent: "error",
  half_day: "warning",
  "day completed": "success",
  "half-day": "warning",
  wfh: "info",
  "on leave": "secondary",
  "auto-absent": "warning",
  // payroll / loans
  requested: "info",
  // recruitment
  applied: "default",
  screening: "info",
  interview: "primary",
  offer: "warning",
  hired: "success",
  // offboarding
  initiated: "warning",
  notice_period: "warning",
  clearance_pending: "warning",
  // priority
  low: "default",
  normal: "info",
  high: "warning",
  urgent: "error",
};

function prettify(v) {
  if (v == null) return "—";
  return String(v).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function StatusChip({ status, size = "small", variant = "filled" }) {
  const key = String(status || "").toLowerCase();
  return <Chip size={size} variant={variant} color={COLOR_MAP[key] || "default"} label={prettify(status)} />;
}
